import { useCallback, useState } from "react";
import { Button } from "../Button";
import { Icons } from "../Icons";
import { Input } from "../Input";
import { Container, FilterContent, RangeContent, DateButton } from "./style";
import endOfDay from "date-fns/endOfDay";
import startOfDay from "date-fns/startOfDay";
import Slider from "@material-ui/core/Slider";
import { Sort } from "../Table/style";
import { DateRange } from "react-date-range";
import { ptBR } from "react-date-range/dist/locale";

export function Filter({
  history,
  match,
  params,
  colKey,
  filter,
  placeholder,
  mask,
  populate,
  min,
  max,
  options,
}) {
  const [input, setInput] = useState("");

  const [dateRange, setDateRange] = useState([
    {
      startDate: startOfDay(new Date()),
      endDate: startOfDay(new Date()),
      key: "selection",
    },
  ]);

  const [range, setRange] = useState([
    min ? min[colKey + (params ? "." + params : "")] : 0,
    max ? max[colKey + (params ? "." + params : "")] : 0,
  ]);

  const sort = useCallback(
    (param) => {
      console.log(param);
      history.push(
        match.path
          .replace(":page", "1")
          .replace(":limit", match.params.limit)
          .replace(":sort", param)
          .replace(":query", match.params.query)
          .replace(":id", match.params.id)
          .replace(":tab", match.params.tab)
      );
      document.getElementById("root").click();
    },
    [history, match]
  );

  const filterHandler = useCallback(
    (e) => {
      e.preventDefault();
      const query = JSON.parse(match.params.query);
      if (filter === "text") {
        if (populate) {
          if (!query.populate) {
            query.populate = [];
          }
          populate.value = input;
          populate.key = colKey;
          query.populate.push(populate);
        } else {
          query[colKey + (params ? "." + params : "")] = {
            $regex: input,
            $options: "i",
          };
        }
      } else if (filter === "date") {
        query[colKey + (params ? "." + params : "")] = {
          $gte: startOfDay(dateRange[0].startDate),
          $lte: endOfDay(dateRange[0].endDate),
        };
      } else if (filter === "range") {
        query[colKey + (params ? "." + params : "")] = {
          $gte: range[0],
          $lte: range[1],
        };
      } else {
        query[colKey + (params ? "." + params : "")] = input;
        if (input === "") {
          delete query.status;
        }
      }
      history.push(
        match.path
          .replace(":page", "1")
          .replace(":limit", match.params.limit)
          .replace(":sort", match.params.sort)
          .replace(":query", JSON.stringify(query))
          .replace(":id", match.params.id)
          .replace(":tab", match.params.tab)
      );
      setInput("");
      document.getElementById("root").click();
    },
    [history, input, match, dateRange, range, colKey, filter, params, populate]
  );

  const FilterButton = useCallback(
    (input) => (
      <Button type="submit" disabled={!input} bg="default" border="default">
        <Icons type="filter" size="18" color="#fff" />
      </Button>
    ),
    []
  );

  const getFilterType = useCallback(
    () => (
      <FilterContent onSubmit={filterHandler}>
        {filter === "text" || filter === "number" ? (
          <>
            {mask ? (
              <Input
                type="inputMaskOnly"
                mask={mask}
                inputType={filter}
                placeholder={placeholder}
                item={input}
                setItem={setInput}
              />
            ) : (
              <Input
                type="inputOnly"
                inputType={filter}
                placeholder={placeholder}
                item={input}
                setItem={setInput}
              />
            )}

            {<FilterButton input={input} />}
          </>
        ) : filter === "status" ? (
          <>
            <Input
              type="selectOnly"
              inputType={filter}
              placeholder="Todos"
              item={input}
              setItem={setInput}
              options={[
                { value: "true", label: "Ativo" },
                { value: "false", label: "Inativo" },
              ]}
            />
            {<FilterButton input={input} />}
          </>
        ) : filter === "select" ? (
          <>
            <Input
              type="selectOnly"
              inputType={filter}
              placeholder="Todos"
              item={input}
              setItem={setInput}
              options={options}
            />
            {<FilterButton input={input} />}
          </>
        ) : filter === "date" ? (
          <div>
            <DateRange
              editableDateInputs={true}
              onChange={(item) => setDateRange([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={dateRange}
              locale={ptBR}
              endDatePlaceholder="Até"
              startDatePlaceholder="De"
              dateDisplayFormat="dd/MM/yyyy"
              color="#009870"
              weekdayDisplayFormat="eeeee"
              rangeColors={["#009870"]}
            />
            <DateButton
              type="submit"
              bg="default"
              border="default"
              color="white"
            >
              Filtrar&nbsp;
              <Icons type="filter" size="18" color="#fff" />
            </DateButton>
          </div>
        ) : filter === "range" ? (
          <RangeContent>
            <Slider
              value={range}
              onChange={(e, newValue) => setRange(newValue)}
              valueLabelDisplay="auto"
              aria-labelledby="range-slider"
              min={min ? min[colKey + (params ? "." + params : "")] : null}
              max={max ? max[colKey + (params ? "." + params : "")] : null}
            />
            <div>
              <Input
                type="inputOnly"
                placeholder="De"
                inputType="number"
                item={range}
                params="0"
                setItem={setRange}
              />
              <Input
                type="inputOnly"
                inputType="number"
                placeholder="Até"
                item={range}
                params="1"
                setItem={setRange}
              />
              <FilterButton input={range} />
            </div>
          </RangeContent>
        ) : null}
      </FilterContent>
    ),
    [
      filter,
      placeholder,
      input,
      mask,
      filterHandler,
      colKey,
      max,
      min,
      range,
      params,
      options,
      dateRange,
    ]
  );

  return (
    <Container>
      <h3>Ordenar</h3>
      <Sort onClick={() => sort(`${colKey}${params ? `.${params}` : ""}`)}>
        Crescente
        <Icons type="asc" color="var(--default)" size={15} />
      </Sort>
      <Sort onClick={() => sort(`-${colKey}${params ? `.${params}` : ""}`)}>
        Decrescente <Icons type="desc" color="var(--default)" size={15} />
      </Sort>
      <h3>Filtrar</h3>
      {getFilterType()}
    </Container>
  );
}
